import { v4 as uuidv4 } from "uuid";
export class TeamGridViewModel {
    constructor() {
        this.teamId = uuidv4();
    }
}
export default class teamList extends TeamGridViewModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
